<template>
  <div>
    <v-container class="pl-10 pr-10 ml-0">
      <div v-if="is_load" class="membership_sms_width">
        <p class="display-1 mt-7">멤버십 SMS 알림 설정</p>
        <p class="mb-0 subtitle-1 font-weight-light">
          멤버십 결제, 기간 만료 전/후 알림, 해지시 안내 관련하여 SMS 알림이
          가능합니다.
        </p>
        <p class="mb-0 subtitle-1 font-weight-light">
          카페24 SMS 문자 서비스를 통해 발송처리되며, SMS 사용설정에
          '사용함'으로 설정되어 있어야
        </p>
        <p class="mb-0 subtitle-1 font-weight-light">
          원활하게 발송이 가능하오니 참고해주세요.
        </p>
      </div>

      <SmsAlarmSetting ref="SmsAlarmSetting"></SmsAlarmSetting>
    </v-container>
    <PageLoadingProgress ref="PageLoadingProgress"></PageLoadingProgress>
  </div>
</template>

<script>
//import SmsAlarmSetting from "@/components/membership/sms_alarm_setting/SmsAlarmSetting.vue";
const SmsAlarmSetting = () =>
  import(
    /* webpackChunkName: "ViewSmsAlarmSetting" */ "@/components/membership/sms_alarm_setting/SmsAlarmSetting.vue"
  );
import PageLoadingProgress from "@/components/common/PageLoadingProgress.vue";

export default {
  data() {
    return {
      is_load: false,
    };
  },
  components: {
    SmsAlarmSetting,
    PageLoadingProgress,
  },
  methods: {
    serchShow: function() {
      this.progressHide();
      this.is_load = true;
      this.$refs.SmsAlarmSetting.is_load = true;
    },

    progressShow: function() {
      this.$refs.PageLoadingProgress.show();
    },
    progressHide: function() {
      this.$refs.PageLoadingProgress.hide();
    },
  },
  mounted: function() {
    this.progressShow();
  },
};
</script>
